import { Button } from '@devizy/ui';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { ChatShell } from '@/components/chat/chat-shell';
import { publicEnv } from '@/lib/env';

export const Route = createFileRoute('/')({
  component: ChatHomePage,
});

function ChatHomePage(): React.ReactElement {
  const t = useTranslations('chat.auth');

  return (
    <ChatShell centered>
      <section className="border-border bg-background w-full max-w-md rounded-xl border p-6 shadow-sm">
        <h1 className="font-display text-lg tracking-tight">{t('memberTitle')}</h1>
        <p className="text-muted-foreground mt-1.5 text-sm">{t('memberBody')}</p>
        <Button asChild className="mt-5 w-full">
          <a href={publicEnv.appUrl}>{t('memberCta')}</a>
        </Button>
      </section>
    </ChatShell>
  );
}
